import { defineMessages } from "react-intl";

export const statusConfig = defineMessages({
  pending: { defaultMessage: "Pending" },
  accepted: { defaultMessage: "Waiting to depart" },
  started: { defaultMessage: "Started" },
  arrived: { defaultMessage: "Arrived" },
  finished: { defaultMessage: "Finished" },
  cancelled: { defaultMessage: "Cancelled" },
});
